// extracted by mini-css-extract-plugin
export default {"main":"xca-z"};